var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs',_vm._b({},'v-tabs',_vm.$attrs,false),_vm._l((_vm.items),function(item,index){return _c('v-tab',{key:index,attrs:{"dark":"","link":"","exact":"","to":item.path}},[_vm._t("tab.item",function(){return [_c('span',[_vm._v(_vm._s(item.label))])]},{"item":item})],2)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }